import React from "react";
import { editData, fetchDataFromApi } from "../../../utils/api";
import { useState } from "react";
import { useEffect } from "react";
import "./style.css";
import { emphasize, styled } from "@mui/material/styles";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Chip from "@mui/material/Chip";
import HomeIcon from "@mui/icons-material/Home";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem"; // Import MenuItem for dropdown
import { MdClose } from "react-icons/md";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "../../../context/SnackbarProvider";

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === "light"
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
});

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [products, setProducts] = useState([]); // Corrected useState variable name
  const [isOpenProductsModal, setIsOpenProductsModal] = useState(false); // Renamed for clarity
  const [isOpenTrackingModal, setIsOpenTrackingModal] = useState(false); // New state for tracking ID modal
  const [currentOrderId, setCurrentOrderId] = useState(null); // To store the ID of the order being updated
  const [currentOrderStatus, setCurrentOrderStatus] = useState(""); // To store the status selected
  const [trackingId, setTrackingId] = useState(""); // New state for tracking ID input
  const history = useNavigate();

  const { showSnackbar } = useSnackbar();

  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));

  // Define all possible order statuses
  const orderStatuses = [
    "pending",
    "confirmed",
    "processing",
    "out for delivery",
    "delivered",
    "cancelled",
    "returned",
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!token || !user || user.role !== "admin") {
      showSnackbar("Forbidden: Insufficient Permissions.", "error", "#f1b9b9");
      history("/");
    }
    fetchOrders(); // Fetch orders on component mount
  }, []); // Added an empty dependency array to run only once

  const fetchOrders = () => {
    fetchDataFromApi(`/api/orders`).then((res) => {
      setOrders(res);
    });
  };

  const showProducts = (id) => {
    fetchDataFromApi(`/api/orders/${id}`).then((res) => {
      setIsOpenProductsModal(true);
      setProducts(res.products);
    });
  };

  const handleStatusChange = (event, orderId) => {
    const newStatus = event.target.value;
    setCurrentOrderId(orderId);
    setCurrentOrderStatus(newStatus);

    if (newStatus === "out for delivery") {
      setIsOpenTrackingModal(true); // Open modal for tracking ID
      setTrackingId(""); // Clear previous tracking ID
    } else {
      updateOrderStatus(orderId, newStatus);
    }
  };

  const updateOrderStatus = async (orderId, status, trackingId = null) => {
    try {
      const res = await fetchDataFromApi(`/api/orders/${orderId}`);
      const order = {
        name: res.name,
        phoneNumber: res.phoneNumber,
        address: res.address,
        pincode: res.pincode,
        amount: parseInt(res.amount),
        paymentId: res.paymentId,
        email: res.email,
        userid: res.userId,
        products: res.products,
        status: status,
        trackingId: trackingId || res.trackingId,
      };

      await editData(`/api/orders/${orderId}`, order);
      showSnackbar("Status updated successfully!", "success", "#aadbaa");
      fetchOrders();
      window.scrollTo({
        top: 200,
        behavior: "smooth",
      });
    } catch (error) {
      console.error("Error updating order status:", error);
      showSnackbar("Failed to update status.", "error", "#f1b9b9");
    }
  };

  const handleTrackingIdSubmit = () => {
    if (trackingId.trim() === "") {
      showSnackbar("Tracking ID is required for 'Out for Delivery' status.", "error", "#f1b9b9");
      return;
    }
    updateOrderStatus(currentOrderId, currentOrderStatus, trackingId);
    setIsOpenTrackingModal(false);
  };

  const showInvoice = (id) => {
    history(`/admin/orders/invoice/${id}`);
  };

  const formatDate = (date) => {
    const d = new Date(date);
    return `${d.getDate().toString().padStart(2, "0")}-${(d.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${d.getFullYear()}`;
  };

  return (
    <>
      <div className="right-content w-100">
        <div className="card shadow border-0 w-100 flex-row p-4 align-items-center">
          <h5 className="mb-0">Orders List</h5>

          <div className="ml-auto d-flex align-items-center">
            <Breadcrumbs
              aria-label="breadcrumb"
              className="ml-auto breadcrumbs_"
            >
              <StyledBreadcrumb
                component="a"
                href="#"
                label="Dashboard"
                icon={<HomeIcon fontSize="small" />}
              />
              <StyledBreadcrumb
                label="Orders"
                deleteIcon={<ExpandMoreIcon />}
              />
            </Breadcrumbs>
          </div>
        </div>

        <div className="card shadow border-0 p-3 mt-4">
          <div className="table-responsive mt-3">
            <table className="table table-bordered table-striped v-align">
              <thead className="thead-dark">
                <tr>
                  <th>Name</th>
                  <th>Phone Number</th>
                  <th>Email</th>
                  <th>Address</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Country</th>
                  <th>Pincode</th>
                  <th>Total Amount</th>
                  <th>Payment Id</th>
                  <th>Date</th>
                  <th>Order Status</th>
                  <th>Tracking ID</th> {/* New column for Tracking ID */}
                  <th>Invoice</th>
                  <th>Products</th>
                </tr>
              </thead>

              <tbody>
                {orders?.length !== 0 &&
                  orders?.map((order, index) => {
                    return (
                      <tr key={index}>
                        <td style={{ minWidth: "150px" }}>{order?.name}</td>
                        <td>{order?.phoneNumber}</td>
                        <td>{order?.email}</td>
                        <td style={{ minWidth: "200px" }}>{order?.address}</td>
                        <td>{order?.city}</td>
                        <td style={{ minWidth: "150px" }}>{order?.state}</td>
                        <td>{order?.country}</td>
                        <td>{order?.pincode}</td>
                        <td>₹{order?.amount}</td>
                        <td>
                          <span className="text-blue fonmt-weight-bold">
                            {order?.paymentId}
                          </span>
                        </td>
                        <td style={{ minWidth: "100px" }}>
                          {formatDate(order?.date)}
                        </td>
                        <td>
                          <TextField
                            select
                            value={order?.status}
                            onChange={(event) =>
                              handleStatusChange(event, order?._id)
                            }
                            variant="outlined"
                            size="small"
                            sx={{ minWidth: 150 }}
                          >
                            {orderStatuses.map((status) => (
                              <MenuItem key={status} value={status}>
                                {status.charAt(0).toUpperCase() + status.slice(1)}
                              </MenuItem>
                            ))}
                          </TextField>
                        </td>
                        <td>
                            {order?.trackingId ? (
                                <span className="text-blue font-weight-bold">{order?.trackingId}</span>
                            ) : (
                                <span className="text-muted">N/A</span>
                            )}
                        </td>
                        <td>
                          <span
                            className="text-blue fonmt-weight-bold cursor"
                            onClick={() => showInvoice(order?._id)}
                          >
                            View Invoice
                          </span>
                        </td>
                        <td>
                          <span
                            className="text-blue fonmt-weight-bold cursor"
                            onClick={() => showProducts(order?._id)}
                          >
                            View Products
                          </span>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Dialog open={isOpenProductsModal} className="productModal">
        <Button className="close_" onClick={() => setIsOpenProductsModal(false)}>
          <MdClose />
        </Button>
        <h4 className="mb-1 font-weight-bold pr-5 mb-4">Products</h4>

        <div className="table-responsive orderTable">
          <table className="table table-striped table-bordered">
            <thead className="thead-dark">
              <tr>
                <th>Product Id</th>
                <th>Product Title</th>
                <th>Image</th>
                <th>Quantity</th>
                <th>Price</th>
                <th>SubTotal</th>
              </tr>
            </thead>

            <tbody>
              {products?.length !== 0 &&
                products?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item?.productId}</td>
                      <td style={{ whiteSpace: "inherit" }}>
                        <span>{item?.productTitle?.substr(0, 30) + "..."}</span>
                      </td>
                      <td>
                        <div className="img">
                          <img src={item?.image} alt={item?.productTitle} />
                        </div>
                      </td>
                      <td>{item?.quantity}</td>
                      <td>{item?.price}</td>
                      <td>{item?.subTotal}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </Dialog>

      {/* Tracking ID Dialog */}
      <Dialog open={isOpenTrackingModal} onClose={() => setIsOpenTrackingModal(false)}>
        <DialogTitle>Enter Tracking ID</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Tracking ID"
            type="text"
            fullWidth
            variant="outlined"
            value={trackingId}
            onChange={(e) => setTrackingId(e.target.value)}
            required
            error={trackingId.trim() === "" && isOpenTrackingModal}
            helperText={trackingId.trim() === "" && isOpenTrackingModal ? "Tracking ID is required" : ""}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsOpenTrackingModal(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleTrackingIdSubmit} color="primary" disabled={trackingId.trim() === ""}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Orders;